export default {
  html: '<[^>]+>',
  firstAndLastQuotes: /^\"|\"$/g, // 匹配首尾引号
  commaOrSemicolon: /\,|;|，|；/g, // 匹配逗号或分号
  numOrletters: /^[A-Za-z0-9]+$/, // 数字和字母
  price: /(^[1-9]\d*(\.\d{1,4})?$)|(^0(\.\d{1,4})?$)/, // 校验价格
  ip: /^((2[0-4]\d|25[0-5]|[01]?\d\d?)\.){3}(2[0-4]\d|25[0-5]|[01]?\d\d?)$/, // ip地址
  email: /^([a-zA-Z0-9]([-_\.](?!-|_|\.|@)|[a-zA-Z0-9])*@[a-zA-Z0-9]([-_](?!-|_|\.)|[a-zA-Z0-9])*(\.[a-zA-Z0-9]([-_](?!-|_|\.|$)|[a-zA-Z0-9])*)+)?$/g// 邮箱
}



// WEBPACK FOOTER //
// ./src/assets/utilits/regulars.js